export type SvzChipSelectionType = 'single' | 'multiple';

export function svzChipNextValues(type: SvzChipSelectionType, currentValues: Array<string | number>, value: string | number): Array<string | number> {
  const isAlreadySelected = currentValues.includes(value);
  if (type === 'single') {
    return isAlreadySelected ? [] : [value];
  }
  return isAlreadySelected ? currentValues.filter((current) => current !== value) : [...currentValues, value];
}
